import { toast as reactHotToast } from 'react-hot-toast';

const defaultConfig = {
  duration: 3000
};

/**
 * @param message
 * @param config
 * @return {string}
 * @description alias to use toast.success instead of toast(
 */
export async function success(message, config = defaultConfig) {
  reactHotToast.success(message, config);
  await new Promise(resolve => setTimeout(resolve, config.duration - 1000));
}

/**
 * @param message
 * @param config
 * @return {string}
 * @description alias to use toast.error instead of toast(
 */
export async function error(message, config = defaultConfig) {
  reactHotToast.error(message, config);
  await new Promise(resolve => setTimeout(resolve, config.duration - 1000));
}

export async function custom(component, config = defaultConfig) {
  reactHotToast.custom(component, config);
  await new Promise(resolve => setTimeout(resolve, config.duration - 1000));
}
